import React, { useState } from "react";
import axios from "axios";
import {
  triggerForgotPassword,
  confirmForgotPassword,
} from "../../utils/cognitoForgotPassword";
import "../../styles/forgotPasswordModal.css";
import { SERVER_URL } from "../../config";

interface Props {
  onClose: () => void;
}

const ForgotPasswordModal: React.FC<Props> = ({ onClose }) => {
  const [step, setStep] = useState<"email" | "confirm">("email");
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);

  const handleSendCode = async () => {
    try {
      setLoading(true);
      await triggerForgotPassword(email);
      setStep("confirm");
      setMsg(null);
    } catch {
      setMsg("Unable to send reset code.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await confirmForgotPassword(email, code, newPass);
      await axios.put(`${SERVER_URL}/api/auth/reset-password`, {
        email,
        newPassword: newPass,
      });
      setMsg("Password reset! You can now sign in.");
    } catch {
      setMsg("Reset failed. Check the code and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-modal">
      <button onClick={onClose} className="back-btn">
        ←
      </button>
      <h2>Reset Password</h2>

      {step === "email" ? (
        <>
          <input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button
            onClick={handleSendCode}
            disabled={loading}
            className="reset-button"
          >
            Send reset code
          </button>
        </>
      ) : (
        <>
          <input
            type="text"
            placeholder="Verification code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <div className="password-block">
            <input
              type={showPass ? "text" : "password"}
              placeholder="New password"
              value={newPass}
              onChange={(e) => setNewPass(e.target.value)}
            />
            <button
              type="button"
              onClick={() => setShowPass((p) => !p)}
              className="secondary-button"
            >
              {showPass ? "Hide" : "Show"}
            </button>
          </div>
          <button onClick={handleConfirm} disabled={loading}>
            Confirm reset
          </button>
        </>
      )}

      {msg && <p className="error-message">{msg}</p>}
    </div>
  );
};

export default ForgotPasswordModal;
